

































































import SelectOption from "@/common/ui/presenters/select-option";
import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { getAllProjects } from "../../../api/project-api";
import { getAllCompanies } from "@/api/company-api";
import emitter from "@/EventBus";
import AccountingSearchOptions from "../presenters/accounting-search-options";

export interface Option {
  [key: string]: SelectOption[];
}

@Component({})
export default class AccountingSearchBar extends Vue {
  @Prop({ required: true }) mode!: string;

  options: AccountingSearchOptions = {
    projectId: "",
    companyId: "",
    status: "",
    dateType: "",
    startDate: "",
    endDate: ""
  };

  projects: SelectOption[] = [];
  companies: SelectOption[] = [];
  isRequired: boolean = false;
  isDisabled: boolean = true;

  status: Option = {
    estimate: [
      {
        text: "全て(ステータス)",
        value: ""
      },
      {
        text: "見込み",
        value: "expected"
      },
      {
        text: "見積中",
        value: "created_new"
      },
      {
        text: "提出前",
        value: "created"
      },
      {
        text: "見積提出",
        value: "quoted_new"
      },
      {
        text: "提出済",
        value: "quoted"
      },
      {
        text: "受注",
        value: "success"
      },
      {
        text: "失注",
        value: "failure"
      }
    ],
    invoice: [
      {
        text: "全て(ステータス)",
        value: ""
      },
      {
        text: "未請求",
        value: "created"
      },
      {
        text: "請求済",
        value: "requested"
      },
      {
        text: "入金済",
        value: "paid"
      },
      {
        text: "無効",
        value: "invalid"
      }
    ],
    purchase: [
      {
        text: "全て(ステータス)",
        value: ""
      },
      {
        text: "未発注",
        value: "created"
      },
      {
        text: "発注済",
        value: "ordered"
      },
      {
        text: "送金済",
        value: "paid"
      },
      {
        text: "無効",
        value: "invalid"
      }
    ]
  };

  dateTypes: Option = {
    estimate: [
      {
        text: "日付指定なし",
        value: ""
      },
      {
        text: "発行日",
        value: String(1)
      },
      {
        text: "受注日",
        value: String(2)
      }
    ],
    invoice: [
      {
        text: "日付指定なし",
        value: ""
      },
      {
        text: "発行日",
        value: String(1)
      },
      {
        text: "入金予定日",
        value: String(2)
      }
    ],
    purchase: [
      {
        text: "日付指定なし",
        value: ""
      },
      {
        text: "発行日",
        value: String(1)
      },
      {
        text: "支払予定日",
        value: String(2)
      }
    ]
  };

  protected created() {
    this.initProjectList();
    this.initCompanyList();
    emitter.emit("initData", this.options);
  }

  get companyOptions() {
    return [
      {
        text: "全て(元請け)",
        value: ""
      },
      ...this.companies.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initCompanyList() {
    this.companies = (await getAllCompanies()).map(p => ({
      text: p.name,
      value: String(p.companyId)
    }));
  }

  get projectOptions() {
    return [
      {
        text: "全て(現場)",
        value: ""
      },
      ...this.projects.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initProjectList() {
    this.projects = (await getAllProjects()).map(p => ({
      text: p.name,
      value: String(p.projectId)
    }));
  }

  get statusOptions(): SelectOption[] {
    return this.status[this.mode];
  }

  get dateTypeOptions() {
    return this.dateTypes[this.mode];
  }

  submit() {
    if (this.checkDateRange()) {
      alert("日付指定が不正です。");

      return;
    }
    this.$emit("handleSearch", this.options);
  }

  @Watch("options.dateType")
  onDateTypeChanged() {
    if (this.options.dateType == "") {
      this.isRequired = false;
      this.isDisabled = true;
      this.resetDate();

      return;
    }

    this.isRequired = true;
    this.isDisabled = false;
  }

  resetDate() {
    this.options.startDate = "";
    this.options.endDate = "";
  }

  checkDateRange() {
    let { startDate, endDate } = this.options;
    if (
      new Date(startDate as string).getTime() >
      new Date(endDate as string).getTime()
    ) {
      return true;
    }

    return false;
  }
}
